import { defineStore } from "pinia";
import axios from "axios";
import { useApplicationStore } from "@/state/pinia";

export const useVehicleStore = defineStore("vehicle", {
    state: () => ({
        endpointResult: null,
        selectedItemId: 0,
        metaData: null,
        monthData: null,
        dayData: null,
        teamsData: null,
        gtcText: null,
        bookingConfirmationData: null,
    }),
    getters: {
        selectedAgency(){
            return this.selectedItemId
        },
        items(){
            if (this.endpointResult !== null){
                return this.endpointResult.data
            }else{
                return {}
            }
        },
        item(){
            if (this.endpointResult !== null){
                return this.endpointResult.data[this.selectedItemId]
            }else{
                return {}
            }
        },
        bookingConfirmation(){
            if (this.bookingConfirmationData !== null){
                return this.bookingConfirmationData.data
            }else{
                return {}
            }
        },
        isUnique(){
            if (this.endpointResult !== null){
                return this.endpointResult.data.length === 1
            }else{
                return false
            }
        },
        hasData(){
            return this.endpointResult !== null;
        },
        textItems(){
            if (this.metaData !== null){
                return this.metaData.data
            }else{
                return {}
            }
        },
        hasTextData(){
            return this.metaData !== null;
        },
        monthItems(){
            if (this.monthData !== null){
                return this.monthData.data
            }else{
                return {}
            }
        },
        hasMonthData(){
            return this.monthData !== null;
        },
        dayItems(){
            if (this.dayData !== null){
                return this.dayData.data.slots.sort((a,b)=> a.date > b.date)
            }else{
                return []
            }
        },
        hasDayData(){
            return this.dayData !== null;
        },
        teamsItems(){
            if (this.teamsData !== null){
                return this.teamsData.data
            }else{
                return {}
            }
        },
        hasTeamsData(){
            return this.teamsData !== null;
        },
        gtc(){
            if (this.gtcText !== null){
                return this.gtcText.data
            }else{
                return ""
            }
        }
    },
    actions: {
        logOut(){
            this.endpointResult = null
            this.selectedItemId = 0
            this.metaData = null
            this.monthData = null
            this.dayData = null
            this.teamsData = null
            this.gtcText = null
            this.bookingConfirmationData = null
        },
        setVehicle(value) {
            this.endpointResult = value
        },
        setMetaText(value) {
            this.metaData = value
        },
        setBookingConfirmationData(value) {
            this.bookingConfirmationData = value
        },
        setGtcText(value) {
            this.gtcText = value
        },
        setMonthData(value) {
            this.monthData = value
        },
        setDayData(value) {
            this.dayData = value
        },
        setTeams(value) {
            this.teamsData = value
        },
        setAgency(id){
            this.selectedItemId = id
        },
        getVehicle(vin){
            const appStore = useApplicationStore();
            appStore.setLoading(true);
            const endpoint = `api/vehicle/${vin}`;
            axios.get(process.env.VUE_APP_URL+endpoint).then((response) => {
                if (response.status === 200) {
                    this.setVehicle(response.data)
                }
            }).catch((error) => {
                console.log(error)
            }).finally(()=>{
                appStore.setLoading(false);
            });
        },
        postBooking(postData){
            const appStore = useApplicationStore();
            appStore.setLoading(true);
            const endpoint = `api/booking/add`;
            axios.post(process.env.VUE_APP_URL+endpoint, postData).then((response) => {
                if (response.status === 200) {
                    this.setBookingConfirmationData(response.data)
                }
            }).catch((error) => {
                console.log(error)
            }).finally(()=>{
                appStore.setLoading(false);
            });
        },
        getMetaText(){
            const appStore = useApplicationStore();
            appStore.setLoading(true);
            const endpoint = `api/meta/text`;
            axios.get(process.env.VUE_APP_URL+endpoint).then((response) => {
                if (response.status === 200) {
                    this.setMetaText(response.data)

                }
            }).catch((error) => {
                console.log(error)
            }).finally(()=>{
                appStore.setLoading(false);
            });
        },
        getGtcText(lang){
            const appStore = useApplicationStore();
            appStore.setLoading(true);
            const endpoint = `api/meta/gtc/${lang}`;
            axios.get(process.env.VUE_APP_URL+endpoint).then((response) => {
                if (response.status === 200) {
                    this.setGtcText(response.data)

                }
            }).catch((error) => {
                console.log(error)
            }).finally(()=>{
                appStore.setLoading(false);
            });
        },
        getMonthData(agency, slots){
            const appStore = useApplicationStore();
            appStore.setLoading(true);
            var endpoint = `api/resource/month/${agency}/${slots}`
            axios.get(process.env.VUE_APP_URL+endpoint).then((response) => {
                if (response.status === 200) {
                    this.setMonthData(response.data)
                }
            }).catch((error) => {
                console.log(error)
            }).finally(()=>{
                appStore.setLoading(false);
            });
        },
        getTeamsData(agency){
            const appStore = useApplicationStore();
            this.setTeams(null)
            appStore.setLoading(true);
            const endpoint = `api/team/${agency}`;
            axios.get(process.env.VUE_APP_URL+endpoint).then((response) => {
                if (response.status === 200) {
                    this.setTeams(response.data)
                }
            }).catch((error) => {
                console.log(error)
            }).finally(()=>{
                appStore.setLoading(false);
            });
        },
        getDayData(agency, slots, date){
            const appStore = useApplicationStore();
            appStore.setLoading(true);
            const endpoint = `api/resource/day/${date}/${agency}/${slots}`;
            axios.get(process.env.VUE_APP_URL+endpoint).then((response) => {
                if (response.status === 200) {
                    this.setDayData(response.data)
                }
            }).catch((error) => {
                console.log(error)
            }).finally(()=>{
                appStore.setLoading(false);
            });
        }
    },
})
